module.exports = __webpack_public_path__ + "img/custom_bg1.d4b5d19a.png";